module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-28-5ec974b483a691c953c535a480f405a5.svg";